import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const ImportExportView = angular
  .module('acme.view.application.importExport', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.importExport.list',
    'acme.view.application.importExport.job',
    'acme.view.application.importExport.jobExecution',
    'acme.view.application.importExport.exportJobExecution',
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const importExport = {
      name: 'application.importExport',
      url: '/import-export',
      abstract: true,
      views: {
        'subview-main': {
          templateUrl: 'views/application/views/importExport/importExport.tpl.html',
        },
      },
      data: {
        pageTitle: 'Import / Export',
      },
    };

    $stateProvider.state(importExport);
  }).name;
